import React from "react"
import { Link } from "react-router-dom";
import {
    WebsiteIcon,
} from "../../assets/icons/icons";
export default function Header(){
    return(
        <header className="shadow-lg shadow-gray-400/30 py-[10px]">
            <div className="container flex justify-between items-center">
                <div className="flex items-center gap-[10px]">
                    <Link to={"/"} className="font-bold">
                        <img className="w-[100px]" src={require("../../assets/logo/logo.png")} alt="" />
                    </Link>
                </div>
                <Link to={"https://aj-mart.com/"} className="flex items-center gap-1 text-white bg-[#1485a6] px-[20px] py-[7px] rounded-[4px]">
                    <WebsiteIcon/>
                    <span>Go To Website</span>
                </Link>
            </div>
        </header>
    )
}